import setStatus from './set-status';
import resetStatus from './reset-status';

export default {
  setStatus,
  resetStatus,
};
